import { UserSessionStore } from '@aon/aon-tws-common-ui';
import { ActionCreators } from '@aon/aon-tws-common-ui/build/lib/components/ClientContext/ClientContextStore';
import { ClientContextSwitch } from '@aon/aon-tws-common-ui/build/lib/components/ClientContext/ClientContextSwitch';
import { connect } from 'react-redux';
import { IApplicationState } from '../../store';

export const ClientContextContainer = connect(
	(state: IApplicationState) => ({
		...state.clientContextList,
	}),
	{ ...ActionCreators, logout: UserSessionStore.logout },
)(ClientContextSwitch as any) as any;
